import React, { useContext } from 'react'
import {Grid, Typography,Paper} from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import {SocketContext} from '../SocketContext';

const useStyles=makeStyles((theme)=>({
    video:{
        width:'550px',
        [theme.breakpoints.down('xs')]:{
            width:'300px',
        },

    },
    gridContainer:{
        justifyContent:'center',
        [theme.breakpoints.down('xs')]:{
            flexDirection:'column',
        },
    },
    paper:{
        padding:'10px',
        border:'1px solid rgba(0,0,0,0.2)',
        margin:'10px',
    },
}));


const VideoPlayer = () => {

    const {name,callAccepted,myVideo,userVideo,callEnded,stream,call}= useContext(SocketContext);
    const classes= useStyles();
    
    return (
        <Grid container className={classes.gridContainer}>
            {/* Our own video */}
            {stream &&(
                <Paper className={classes.paper}>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h5" gutterBottom style={{color:'#9323EB',fontFamily: 'Ubuntu'}}>{name || 'Name'}</Typography>
                        <video playsInline muted ref={myVideo} autoPlay className={classes.video}></video>
                    </Grid>
                </Paper>
            )}
            
            {/* users video */}
            {
                callAccepted && !callEnded &&(
                <Paper className={classes.paper}>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h5" gutterBottom style={{color:'#9323EB',fontFamily: 'Ubuntu'}}>{call.name || 'Name'}</Typography>
                        <video playsInline  ref={userVideo} autoPlay className={classes.video}></video>
                    </Grid>
                </Paper>
                )
            }
            
        </Grid>
    );
}

export default VideoPlayer;
